import { SYSTEM_ROLES } from '../../config/roles.config';
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class RolesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'roles';
        this.Server = this.props.context.getState().server.roles;

        this.searchFields = ['name'];

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
                // needTranslate: true
            },
            {
                id: 'systemRole',
                label: 'systemRole',
                alignRight: false,
                cell: 'Items',
                items: [SYSTEM_ROLES.ADMIN],
                filterCell: 'Items',
                filterBy: 'systemRole',
                displayGrid: true,
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName',
            },
            {
                id: 'isDefault',
                label: 'isDefault',
                alignRight: false,
                cell: 'SystemRole',
                trueLabel: 'isSystemRole',
                falseLabel: 'isNotSystemRole',
                type: 'boolean',
                displayGrid: true,
                onlyRead: true,
                // filterCell: 'Boolean'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
